import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';

import styles from './ChatEndFeedbackPopup.module.scss';

interface Props {
  isOpen: boolean;
  title: string;
  description?: string;
  primaryBtnText: string;
  secondaryBtnText?: string;
  isEndChatPopup?: boolean;
  primaryBtnColor?: string;
  onAccept: () => void;
  onCancel: () => void;
  isFixedButtonSize?: boolean;
}

const ChatEndFeedbackPopup: React.FC<Props> = ({
  isOpen,
  title,
  description,
  primaryBtnText,
  secondaryBtnText,
  isEndChatPopup = false,
  primaryBtnColor = '#0082B9',
  onAccept,
  onCancel,
  isFixedButtonSize = false,
}) => (
  <Modal
    isOpen={isOpen}
    className={styles.modal}
    overlayClassName={styles.overlay}
    ariaHideApp={false}
  >
    <div className={classNames(styles.card, {
      [styles.cardEndChat]: isEndChatPopup,
    })}
    >
      <span className={styles.title}>{title}</span>
      {description
      && (
        <p className={classNames(styles.description, {
          [styles.descriptionText]: isEndChatPopup,
        })}
        >{description}
        </p>
      )}
      <div className={classNames(styles.buttons, {
        [styles.buttonsWraps]: isEndChatPopup,
      })}
      >
        <button
          type="button"
          className={classNames(styles.primaryBtn, {
            [styles.primaryBtnSize]: isFixedButtonSize,
          })}
          style={{ background: primaryBtnColor }}
          onClick={onAccept}
        >
          {primaryBtnText}
        </button>
        {secondaryBtnText && (
          <button
            type="button"
            className={classNames(styles.secondaryBtn, {
              [styles.secondaryBtnBordered]: isEndChatPopup,
            })}
            onClick={onCancel}
          >
            {secondaryBtnText}
          </button>
        )}
      </div>
    </div>
  </Modal>
);

ChatEndFeedbackPopup.defaultProps = {
  description: undefined,
  secondaryBtnText: undefined,
  isEndChatPopup: false,
  primaryBtnColor: '#0082B9',
  isFixedButtonSize: false,
};

export default ChatEndFeedbackPopup;
